import BranchOrderAddParcelBox from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderParcelPicker/BranchOrderAddParcelBox';
import BranchOrderParcelBox from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderParcelPicker/BranchOrderParcelBox';
import { packageCreate } from 'global/Models/omOrderModel';
import { packagingCreate } from 'global/Models/packagingModel';
import { FC, useMemo } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { BsBoxSeam } from 'react-icons/bs';

interface IOrderParcelSection {
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  index: number;
  packages: packageCreate[];
}

const BranchOrderParcelSection: FC<IOrderParcelSection> = ({ setPackages, index, packages }) => {
  //functions

  const lockerInfo = useMemo(() => packages[index].lockerInfo, [packages, index]);

  const addPackage = (pack?: packagingCreate) => {
    if (!pack) return;
    setPackages((prevState) => {
      const temp = prevState.map((p, i) => {
        if (i !== index) return p;
        return { ...p, package: [...p.package, pack] };
      });
      return temp;
    });
  };

  const deleteSinglePackaging = (packagingIndex: number) => {
    setPackages((prevState) => {
      const tempPackages = [...prevState];
      prevState[index].package = prevState[index].package?.filter((item, index) => index !== packagingIndex);
      return tempPackages;
    });
  };
  const handleCountChange = (count: number | undefined, packagingIndex: number) => {
    setPackages((prevState) => {
      const temp = prevState.map((p, i) => {
        if (i !== index) return p;
        return {
          ...p,
          package: p.package.map((pa, k) => {
            if (k !== packagingIndex) return pa;
            return { ...pa, count };
          }),
        };
      });
      return temp;
    });
  };
  const handleDescChange = (description: string, packagingIndex: number) => {
    setPackages((prevState) => {
      const temp = prevState.map((p, i) => {
        if (i !== index) return p;
        return {
          ...p,
          package: p.package.map((pa, k) => {
            if (k !== packagingIndex) return pa;
            return { ...pa, description };
          }),
        };
      });
      return temp;
    });
  };

  const handleBarcodeChange = (barcodes: string[], packagingIndex: number) => {
    // console.log('handleBarcodeChange called:', barcodes);
    setPackages((prev) =>
      prev.map((p, i) =>
        i !== index
          ? p
          : {
              ...p,
              package: p.package.map((pa, k) => (k !== packagingIndex ? pa : { ...pa, barcodes: [...barcodes] })),
            }
      )
    );
  };

  //constants
  const pack = useMemo(() => {
    const pack = packages[index];
    if (!pack) return [];
    return pack.package;
  }, [packages, index]);

  return (
    <div className='flex flex-col gap-2'>
      <span className='flex items-center gap-1 mx-auto font-bold text-t-primary-color inherit-color'>
        <BsBoxSeam className='text-base' />
        مرسوله
      </span>
      {!lockerInfo && <BranchOrderAddParcelBox setPackage={addPackage} packaging={undefined} />}
      {lockerInfo && (
        <div className='text-xs text-t-secondary-text-color color-inherit'>
          <BiInfoCircle className='relative inline-block top-1' /> پس از رزرو لاکر امکان تغییر مرسوله وجود ندارد{' '}
        </div>
      )}
      {pack?.map((packaging, i) => (
        <BranchOrderParcelBox
          key={index + i}
          packagingIndex={i}
          setPackage={addPackage}
          packaging={packaging}
          handleDelete={deleteSinglePackaging}
          handleCountChange={handleCountChange}
          handleDescChange={handleDescChange}
          isLockerReserved={!!lockerInfo}
          handleBarcodeChange={handleBarcodeChange}
        />
      ))}
    </div>
  );
};

export default BranchOrderParcelSection;
